export const A_TOUR_SEARCH = "A_TOUR_SEARCH";
export const A_TOUR_SEARCH_FOR_COMMON_FILTERS = "A_TOUR_SEARCH_FOR_COMMON_FILTERS";
export const A_SET_SEARCHED = "A_SET_SEARCHED";
export const A_SIGN_IN = "A_SIGN_IN";
export const A_LOGOUT = "A_LOGOUT";
export const A_GET_REGISTRATION_PASSWORD = "A_GET_REGISTRATION_PASSWORD";
export const A_GET_REGISTRATION_NO_PASSWORD = "A_GET_REGISTRATION_NO_PASSWORD";
export const A_GET_PERSONAL_SEND_MAIL = "A_GET_PERSONAL_SEND_MAIL";
export const A_RENDER_PRICE_TABLE = "A_RENDER_PRICE_TABLE";
export const A_CHANGE_PRICE_TABLE_CITY = "A_CHANGE_PRICE_TABLE_CITY";
export const A_SET_PRICE_TABLE = "A_SET_PRICE_TABLE";
export const A_SET_SEARCH_SECOND_PARAMS = "A_SET_SEARCH_SECOND_PARAMS";
export const A_CHANGE_SECOND_FILTER = "A_CHANGE_SECOND_FILTER";
export const A_SET_HOTEL_DETAILS = "A_SET_HOTEL_DETAILS";
export const A_GET_NEXT_PAGE = "A_GET_NEXT_PAGE";
export const A_SEARCH_OUT_HOTEL = "A_SEARCH_OUT_HOTEL";
export const A_SET_SEARCH_IN_OUT = "A_SET_SEARCH_IN_OUT";
export const A_GET_MAX_PRICE = "A_GET_MAX_PRICE";
export const A_SET_API_URL = "A_SET_API_URL";
export const A_SET_API_ORIGIN = "A_SET_API_ORIGIN";
export const A_GET_HOTELS_FOR_MAP = "A_GET_HOTELS_FOR_MAP";
export const A_GET_CO_INFO = "A_GET_CO_INFO";
export const A_GET_TRANSPORT_SEATS_INFO = "A_GET_TRANSPORT_SEATS_INFO";
export const A_GET_PRICE_TABLE = "A_GET_PRICE_TABLE";
export const A_GET_PRICE_TABLE_OUT_HOTEL = "A_GET_PRICE_TABLE_OUT_HOTEL";
export const A_GET_COUNTRY_INFO = "A_GET_COUNTRY_INFO";
export const A_COLLAPSE_BY_HOTEL = "A_COLLAPSE_BY_HOTEL";
export const A_COLLAPSE = "A_COLLAPSE";
export const A_SEARCH_COMBO = "A_SEARCH_COMBO";
